import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import BackgroundImage from "gatsby-background-image"
import tw from "twin.macro"

import { Leading } from "./layout"

import GooglePlayBadge from "../images/google-play-badge.svg"
import AppStoreBadge from "../images/app-store-badge.svg"

const HeroContainer = tw.div`container mx-auto px-4 flex flex-col md:flex-row md:items-center justify-between`
const HeroContent = tw.div`md:w-1/2 lg:w-1/3`
const HeroTitle = tw.h1`text-ql-blue text-2xl md:text-3xl lg:text-4xl leading-tight`
const HeroText = tw(Leading)`text-base md:text-xl`
const BadgeLink = tw.a`mr-2`
const Badge = tw.img`h-12 inline-block`
const HeroImg = tw(Img)`h-full`
const HeroImgContainer = tw.div`h-full md:w-1/2`

const Hero = () => {
  const data = useStaticQuery(graphql`
    query {
      heroBackground: file(relativePath: { eq: "hero-background.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      heroImage: file(relativePath: { eq: "hero-image.png" }) {
        childImageSharp {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <BackgroundImage fluid={data.heroBackground.childImageSharp.fluid}>
      <HeroContainer>
        <HeroContent>
          <HeroTitle>Say goodbye to hand-written specimen labels</HeroTitle>
          <HeroText>
            Labelscape is an app for clinical sites and laboratories to print
            labels for specimens, kits, and more. It’s designed to work with
            readily available desktop printing supplies for fast, easy label
            creation.
          </HeroText>
          <BadgeLink href="https://play.google.com/store/apps/details?id=org.frontierscience.mobile.LabelApp">
            <Badge src={GooglePlayBadge} />
          </BadgeLink>
          <BadgeLink href="https://apps.apple.com/us/app/labelscape/id1532093916">
            <Badge src={AppStoreBadge} />
          </BadgeLink>
        </HeroContent>
        <HeroImgContainer>
          <HeroImg fluid={data.heroImage.childImageSharp.fluid} />
        </HeroImgContainer>
      </HeroContainer>
    </BackgroundImage>
  )
}

export default Hero
